import { handleActions } from 'redux-actions'

import { ACTION_PREFIX } from './consts'

export const initState = {
  init: false,
  entries: null,
  default: null,
}

/**
 * Root reducer
 */
export const reducers = handleActions(
  {
    INIT: {
      REQUEST: (state, action) => ({
        ...state,
        entries: action.payload.data,
        default: action.payload.data.find((t) => t.default),
      }),
      SUCCESS: (state, action) => ({
        ...state,
        init: true,
      }),
    },
  },
  initState,
  {
    prefix: ACTION_PREFIX,
  },
)
